import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b878e218"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-container",
  class: "d-flex"
}
const _hoisted_2 = { class: "d-flex flex-column me-2 left-width flex-shrink-0" }
const _hoisted_3 = { class: "b-black fc top-height flex-shrink-0" }
const _hoisted_4 = {
  id: "control-voucher",
  class: "b-black br-n pa-5"
}
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(субъект Российской Федерации)", -1))
const _hoisted_7 = {
  class: "card-text",
  style: {"width":"30%"}
}
const _hoisted_8 = { class: "bottom-line" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(номер карты)", -1))
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = {
  class: "mr-5 card-text",
  style: {"width":"70%"}
}
const _hoisted_12 = { class: "bottom-line" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(муниципальное образование)", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-text",
  style: {"width":"30%"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "bottom-line" }, " ")
], -1))
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Контрольный талон к идентификационной карте", -1))
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = {
  class: "mr-5 card-text",
  style: {"width":"85%"}
}
const _hoisted_19 = { class: "bottom-line d-block" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(ФИО)", -1))
const _hoisted_21 = {
  class: "card-text",
  style: {"width":"15%"}
}
const _hoisted_22 = { class: "bottom-line" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(категория гражданина)", -1))
const _hoisted_24 = { class: "card-text" }
const _hoisted_25 = { class: "bottom-line" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(адрес)", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(данные документа)", -1))
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex\" data-v-b878e218><p class=\"text-center\" style=\"width:10%;\" data-v-b878e218>получил: </p><div class=\"card-text\" style=\"width:90%;\" data-v-b878e218><p class=\"bottom-line\" data-v-b878e218> </p><p class=\"subtext\" data-v-b878e218>(подпись, дата, расшифровка)</p></div></div>", 1)
const _hoisted_29 = { class: "d-flex flex-column w-100" }
const _hoisted_30 = { class: "d-flex top-height flex-shrink-0" }
const _hoisted_31 = {
  id: "attachment-qr",
  class: "b-black fc flex-shrink-0 br-n"
}
const _hoisted_32 = {
  id: "attachment-voucher",
  class: "b-black w-100 d-flex flex-column pa-5"
}
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-text",
  style: {"width":"30%"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "bottom-line" }, " ")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(субъект Российской Федерации)", -1))
const _hoisted_36 = {
  class: "card-text",
  style: {"width":"30%"}
}
const _hoisted_37 = { class: "bottom-line" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(номер карты)", -1))
const _hoisted_39 = { class: "card-text" }
const _hoisted_40 = { class: "bottom-line" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(муниципальное образование)", -1))
const _hoisted_42 = { class: "d-flex" }
const _hoisted_43 = {
  class: "mr-5 card-text",
  style: {"width":"80%"}
}
const _hoisted_44 = { class: "bottom-line d-block" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(ФИО)", -1))
const _hoisted_46 = {
  class: "card-text",
  style: {"width":"20%"}
}
const _hoisted_47 = { class: "bottom-line" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(категория гражданина)", -1))
const _hoisted_49 = { class: "fc h-100" }
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Прикрепительный талон к идентификационной карте", -1))
const _hoisted_52 = {
  class: "mt-2 h-100 b-black bl-n bt-n w-100",
  style: {"table-layout":"fixed"}
}
const _hoisted_53 = {
  key: 0,
  class: "fc"
}
const _hoisted_54 = { class: "cell-info" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_57 = {
  rowspan: "7",
  colspan: "6",
  class: "b-black bb-n br-n"
}
const _hoisted_58 = {
  id: "id-card",
  class: "d-flex h-100"
}
const _hoisted_59 = {
  class: "d-flex flex-column h-100",
  style: {"width":"25%","border-right":"1px solid black"}
}
const _hoisted_60 = {
  class: "fc pa-5",
  style: {"height":"20%"}
}
const _hoisted_61 = {
  class: "text-center",
  style: {"word-break":"break-all"}
}
const _hoisted_62 = {
  class: "b-black bl-n br-n fc",
  style: {"height":"40%"}
}
const _hoisted_63 = { class: "pa-5" }
const _hoisted_64 = { class: "card-text" }
const _hoisted_65 = { class: "bottom-line" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(категория гражданина)", -1))
const _hoisted_67 = { class: "card-text" }
const _hoisted_68 = { class: "bottom-line" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(документ)", -1))
const _hoisted_70 = { class: "card-text" }
const _hoisted_71 = { class: "bottom-line" }
const _hoisted_72 = {
  class: "pa-5 d-flex flex-column justify-space-between",
  style: {"width":"75%"}
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(субъект Российской Федерации)", -1))
const _hoisted_74 = { class: "card-text" }
const _hoisted_75 = { class: "bottom-line" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(муниципальное образование)", -1))
const _hoisted_77 = { class: "text-center" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"xxx-large"} }, "ИДЕНТИФИКАЦИОННАЯ КАРТА", -1))
const _hoisted_79 = { class: "d-flex" }
const _hoisted_80 = {
  class: "mr-5 card-text",
  style: {"width":"80%"}
}
const _hoisted_81 = { class: "bottom-line" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(ФИО)", -1))
const _hoisted_83 = {
  class: "card-text",
  style: {"width":"20%"}
}
const _hoisted_84 = { class: "bottom-line" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(дата рождения)", -1))
const _hoisted_86 = { class: "card-text" }
const _hoisted_87 = { class: "bottom-line" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(адрес)", -1))
const _hoisted_89 = { class: "d-flex subtext" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { class: "d-flex" }
const _hoisted_92 = {
  class: "card-text",
  style: {"width":"90%"}
}
const _hoisted_93 = { class: "bottom-line" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "(выдал)", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-text",
  style: {"width":"10%"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "bottom-line" }, " "),
  /*#__PURE__*/_createElementVNode("p", { class: "subtext" }, "М.П.")
], -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "При утере не возобновляется")
], -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_99 = {
  key: 0,
  class: "fc"
}
const _hoisted_100 = { class: "cell-info" }

import {
  Citizen,
  IdentityCard,
  citizenGetFullname,
  CitizenDocumentInfo,
  citizenGetAddress,
  userGetFullname,
  createCardNumber,
  User,
  citizenCategoryShorthand,
  MunicipalEntity,
  CardIssuePoint,
  ProductCategory,
  PRODUCT_CATEGORIES_INFO,
  MAX_COUPONS_BY_CATEGORY,
} from '@prodcard/core'
import { chunk, times } from 'lodash'
import QrcodeVue from 'qrcode.vue'
import { ProdInfo } from '../interfaces'

interface DistributionInfo {
  amount: number
  actualAmount: number
  val: string
}
interface ProdCell {
  val: string
  amount: number
  position: string
  num: number
}

const region = 'Ростовская область'


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizenCardPdf',
  props: {
    citizen: {},
    currentUser: {},
    citizenDocumentInfo: {},
    identityCard: {},
    municipalEntity: {},
    cardIssuePoint: {},
    prodInfos: {}
  },
  setup(__props: any) {

const props = __props;



const prods: DistributionInfo[] = []

const distibutionOrder = [
  ...new Set([
    ProductCategory.BREAD,
    ProductCategory.GROATS,
    ProductCategory.VEGETABLES,
    ProductCategory.SUGAR,
    ProductCategory.MEAT,
    ProductCategory.FISH,
    ProductCategory.FATS,
    ProductCategory.SALT,
    ...Object.values(ProductCategory),
  ]),
]

distibutionOrder.forEach(category => {
  const prodInfo = props.prodInfos.find(info => info.category === category)
  if (!prodInfo) return

  prods.push({
    amount: MAX_COUPONS_BY_CATEGORY[category],
    actualAmount: prodInfo.amount,
    val: `${PRODUCT_CATEGORIES_INFO[category].shorthand}=${prodInfo.standard}`,
  })
})

const total = prods.reduce((t, val) => {
  return t + val.amount
}, 0)
const insufficient = 84 - total
if (insufficient > 0) {
  prods.push({ amount: insufficient, actualAmount: insufficient, val: '' })
}

const prodCells: ProdCell[] = []

const cardNumber = createCardNumber(
  props.citizen,
  props.identityCard.createdAt,
  props.municipalEntity?.index || 0,
  props.cardIssuePoint?.number || 0,
)

const cardMonth = new Date(1, props.identityCard.month, 1).toLocaleDateString('default', {
  month: 'long',
})
const docInfo = `${props.citizenDocumentInfo.name}: ${props.citizenDocumentInfo.info}`
const qrValue = `${cardNumber} ${citizenGetFullname(props.citizen)} ${docInfo} ${cardMonth}.${props.identityCard.year}`
const leftCellIds = [30, 31, 34, 35, 38, 39, 42, 43, 46, 47, 50, 51]
const rightCellIds = [32, 33, 36, 37, 40, 41, 44, 45, 48, 49, 52, 53]

let filled = 0
prods.forEach(prod => {
  let position = ''
  // определяем в какой стороне должны быть ячейки
  if (filled < 30) {
    position = 'top'
  } else if (filled < 42) {
    position = 'left'
  } else if (filled < 54) {
    position = 'right'
  } else {
    position = 'bottom'
  }

  for (let i = 0; i < prod.amount; i++) {
    let cellIndex = filled
    let num = i
    switch (position) {
      // верхние просто кладём по индексу текущей заполненной ячейки
      case 'top':
        break

      case 'left':
        // левые кладём слева, если левые индексы кончились - берём первый правый и меняем сторону
        if (leftCellIds.length > 0) {
          cellIndex = leftCellIds.shift() || 0
        } else {
          cellIndex = rightCellIds.shift() || 0
          position = 'right'
        }
        break

      case 'right':
        // если кончились правые - меняем сторону на нижнюю
        if (rightCellIds.length > 0) {
          cellIndex = rightCellIds.shift() || 0
        } else {
          position = 'bottom'
        }
        num = prod.actualAmount - (i + 1)
        break

      case 'bottom':
        // для нижних переворачиваем цифру
        num = prod.actualAmount - (i + 1)
        break
    }
    prodCells[cellIndex] = { ...prod, num, position, val: prod.actualAmount > i ? prod.val : '' }
    filled++
  }
})

const shorthandInfos = chunk(
  props.prodInfos.map(info => ProductCategory[info.category]),
  5,
)

const prodCellRows = {
  top: times(3, i => prodCells.slice(i * 10, i * 10 + 10)), // 3 x 10
  middle: times(6, i => prodCells.slice(i * 4 + 30, i * 4 + 34)), // 6 x 4, offset 30
  bottom: times(3, i => prodCells.slice(i * 10 + 54, i * 10 + 64)), // 3 x 10, offset 54
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(QrcodeVue, {
          value: qrValue,
          size: 380,
          level: 'H',
          "render-as": "svg"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "mr-5 card-text",
            style: {"width":"70%"}
          }, [
            _createElementVNode("p", { class: "bottom-line" }, _toDisplayString(region)),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(cardNumber)), 1),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.municipalEntity?.name || '-'), 1),
            _hoisted_13
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("p", null, [
            _createTextVNode(" на продовольственные и непродовольственные товары на "),
            _createElementVNode("strong", null, _toDisplayString(_unref(cardMonth)) + " " + _toDisplayString(_ctx.identityCard.year), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("strong", _hoisted_19, _toDisplayString(_unref(citizenGetFullname)(_ctx.citizen)), 1),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(citizenCategoryShorthand)(_ctx.citizen.category)), 1),
            _hoisted_23
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(citizenGetAddress)(_ctx.citizen)), 1),
          _hoisted_26
        ]),
        _createElementVNode("div", { class: "card-text" }, [
          _createElementVNode("p", { class: "bottom-line" }, _toDisplayString(docInfo)),
          _hoisted_27
        ]),
        _hoisted_28
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(QrcodeVue, {
            value: qrValue,
            size: 300,
            level: 'H',
            "render-as": "svg"
          })
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", {
              class: "mr-5 card-text",
              style: {"width":"40%"}
            }, [
              _createElementVNode("p", { class: "bottom-line" }, _toDisplayString(region)),
              _hoisted_35
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(cardNumber)), 1),
              _hoisted_38
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.municipalEntity?.name || '-'), 1),
            _hoisted_41
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("strong", _hoisted_44, _toDisplayString(_unref(citizenGetFullname)(_ctx.citizen)), 1),
              _hoisted_45
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("p", _hoisted_47, _toDisplayString(_unref(citizenCategoryShorthand)(_ctx.citizen.category)), 1),
              _hoisted_48
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("p", null, [
                _createTextVNode(" на продовольственные и непродовольственные товары на "),
                _createElementVNode("strong", null, _toDisplayString(_unref(cardMonth)) + " " + _toDisplayString(_ctx.identityCard.year), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_52, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prodCellRows.top, (row, rowId) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowId,
            class: "tr-h"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
              return (_openBlock(), _createElementBlock("td", {
                key: cell.num,
                class: "b-black bb-n br-n"
              }, [
                (cell.val)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("p", _hoisted_54, _toDisplayString(cell.num + 1) + ". " + _toDisplayString(cell.val), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        }), 128)),
        _createElementVNode("tr", null, [
          _hoisted_55,
          _hoisted_56,
          _createElementVNode("td", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("p", _hoisted_61, _toDisplayString(_unref(cardNumber)), 1)
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createVNode(QrcodeVue, {
                    value: qrValue,
                    size: 250,
                    level: "H",
                    "render-as": "svg"
                  })
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("p", _hoisted_65, _toDisplayString(_unref(citizenCategoryShorthand)(_ctx.citizen.category)), 1),
                    _hoisted_66
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.citizenDocumentInfo.name), 1),
                    _hoisted_69
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.citizenDocumentInfo.info), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", { class: "card-text" }, [
                  _createElementVNode("p", { class: "bottom-line" }, _toDisplayString(region)),
                  _hoisted_73
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.municipalEntity?.name || '-'), 1),
                  _hoisted_76
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("p", null, [
                    _createTextVNode(" на продовольственные и непродовольственные товары на "),
                    _createElementVNode("strong", null, _toDisplayString(_unref(cardMonth)) + " " + _toDisplayString(_ctx.identityCard.year), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("p", _hoisted_81, _toDisplayString(_unref(citizenGetFullname)(_ctx.citizen)), 1),
                    _hoisted_82
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("p", _hoisted_84, _toDisplayString(new Date(_ctx.citizen.birthdate).toLocaleDateString('ru-Ru')), 1),
                    _hoisted_85
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("p", _hoisted_87, _toDisplayString(_unref(citizenGetAddress)(_ctx.citizen)), 1),
                  _hoisted_88
                ]),
                _createElementVNode("div", _hoisted_89, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shorthandInfos), (shorthandInfo, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: {"width":"50%"},
                      key: 'shorthand_info_' + index
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shorthandInfo, (cat) => {
                        return (_openBlock(), _createElementBlock("p", { key: cat }, [
                          _createElementVNode("strong", null, _toDisplayString(_unref(PRODUCT_CATEGORIES_INFO)[cat].shorthand), 1),
                          (_unref(PRODUCT_CATEGORIES_INFO)[cat].shorthand !== _unref(PRODUCT_CATEGORIES_INFO)[cat].description)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_90, " - " + _toDisplayString(_unref(PRODUCT_CATEGORIES_INFO)[cat].description), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("p", _hoisted_93, _toDisplayString(_unref(userGetFullname)(_ctx.currentUser)), 1),
                    _hoisted_94
                  ]),
                  _hoisted_95
                ]),
                _hoisted_96
              ])
            ])
          ]),
          _hoisted_97,
          _hoisted_98
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...prodCellRows.middle, ...prodCellRows.bottom], (row, rowId) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowId,
            class: "tr-h"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
              return (_openBlock(), _createElementBlock("td", {
                key: cell.num,
                class: "b-black bb-n br-n"
              }, [
                (cell.val)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                      _createElementVNode("p", _hoisted_100, _toDisplayString(cell.num + 1) + ". " + _toDisplayString(cell.val), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})